import { FavProduct } from './FavProduct'

export default FavProduct